module.exports = __webpack_public_path__ + "img/img_throw_1@2x_v2.62030776.png";